import { useContext } from 'react';

import { SearchDomainConfigProviderContext } from './SearchDomainConfigProvider.context.ts';

export const useSearchDomainConfig = () => {
  const context = useContext(SearchDomainConfigProviderContext);
  if (!context) {
    throw new Error('useSearchDomainConfig must be used within a SearchDomainConfigProvider');
  }
  return context;
};
